export default "* Massage\n* Røre\n* Lytte\n";